export const mainFeatures = [
  {
    icon: "project-diagram",
    imageUrl:
      "https://lf-code-agent.coze.cn/obj/x-ai-cn/259586967042/attachment/image_20250822055541.png",
  },
  {
    icon: "window-maximize",
    imageUrl:
      "https://lf-code-agent.coze.cn/obj/x-ai-cn/259586967042/attachment/image_20250822055416.png",
  },
  {
    icon: "shield",
    imageUrl:
      "https://lf-code-agent.coze.cn/obj/x-ai-cn/259586967042/attachment/image_20250822055807.png",
  },
  {
    icon: "clipboard-check",
    imageUrl:
      "https://lf-code-agent.coze.cn/obj/x-ai-cn/259586967042/attachment/image_20250822055653.png",
  },
  {
    icon: "user-check",
    imageUrl:
      "https://lf-code-agent.coze.cn/obj/x-ai-cn/259586967042/attachment/image_20250822055957.png",
  },
  {
    icon: "chart-line",
    imageUrl:
      "https://lf-code-agent.coze.cn/obj/x-ai-cn/259586967042/attachment/image_20250822060048.png",
  },
];
// 其他特性列表
export const otherFeatures = [
  {
    icon: "rocket",
  },
  {
    icon: "hourglass-half",
  },
  {
    icon: "code-commit",
  },
  {
    icon: "user-tie",
  },
  {
    icon: "code-branch",
  },
  {
    icon: "plug",
  },
  {
    icon: "code-commit",
  },
  {
    icon: "language",
  },
  {
    icon: "sync",
  },
];
